<template>
  <b-button
    variant="outline-dark"
    class="__selected-filter--white"
    size="sm"
    @click.stop="click"
  >
    {{ text }}
    <span
      v-if="number"
      class="ml-25"
    >({{ number }})</span>
    <b-button-close
      class="ml-25 mb-25"
      @click.stop="clearFilter"
    />
  </b-button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    number: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const click = () => {
      context.emit('click', props.text)
    }

    const clearFilter = () => {
      context.emit('clearFilter', props.text)
    }

    return { click, clearFilter }
  },
}
</script>
<style lang="scss">
.__selected-filter--white{
  background-color: white;
  .close {
    font-size: 1.5rem;
    line-height: 0.875rem;
    font-weight: 100;
    color: #6e6e6e !important;
    opacity: 1;
    &:hover {
      color: #5e5873 !important;
    }
    &:focus-visible {
      outline: inherit;
    }
    &:focus {
      outline: inherit;
    }
  }
}
</style>
